<template>
  <div :class="classes" :ref="name">
    <div class="c-moduler-range" :style="collapsed">
      <div class="c-moduler-title" v-if="title">
        <div class="title-wrap">
          <span @click="toggle" :id="name">{{ title }}</span>
          <slot name="head"></slot>
        </div>
        <Icon v-if="collapsible" type="ios-arrow-forward" :size="36" color="#aaa" @click="toggle" />
        <Icon v-else type="ios-arrow-down" :size="36" color="#aaa" @click="toggle" />
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'moduler',
  props: {
    title: {
      type: String
    },
    name: {
      type: String
    },
    media: {
      type: Number,
      default() {
        return 10
      }
    }
  },
  computed: {
    classes() {
      return ['c-moduler', { 'c-border': !this.title }]
    },
    collapsed() {
      return this.collapsible && this.title ? { height: '40px', overflow: 'hidden' } : ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setModuler()
    })
  },
  methods: {
    setModuler() {
      const top = this.$refs[this.name].offsetTop
      const height = this.$refs[this.name].offsetHeight
      const [min, max] = [top, top + height]
      let storeName
      if (this.media === 10) storeName = 'Toutiao'
      else if (this.media === 6) storeName = 'UC'
      else if (this.media === 16) storeName = 'Tencent'
      else if (this.media === 45) storeName = 'Baidu'
      else if (this.media === 32) storeName = 'Kuaishou'
      this.$store.commit(`${storeName}/setModulerLinks`, {
        name: this.name,
        min: min < 40 ? 0 : min - 12,
        max
      })
    },
    toggle() {
      const check = this.collapsible
      this.collapsible = !check
    }
  },
  data() {
    return {
      collapsible: false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-moduler {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;
  margin-bottom: 12px;
  position: relative;
  padding: 36px 24px 48px 48px;

  .c-moduler-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 36px;

    span {
      font-size: 22px;
      line-height: 30px;
      cursor: pointer;
    }

    i {
      cursor: pointer;
    }
  }
}

.c-border {
  padding: 0;
}
</style>
